import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { head, last } from 'lodash';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { mq } from '@styles/breakpoints';
import { DURATIONS } from '@model/price-calendar';
import { getDealFinderDuration } from '@state/slices/deal-finder/dealFinderSelectors';
import { setDuration } from '@state/slices/deal-finder/dealFinderSlice';
import { useI18NextContext } from '@components/hooks';
import { Counter } from '@components/common/counter';
import { TestId } from '@components/test-ids';

const Container = styled.div(({ theme }: ThemeProps) => ({
  alignItems: 'center',
  columnGap: theme.custom.spacing.medium,
  display: 'flex',
  flexDirection: 'column',
  fontSize: '1.5rem',
  justifyContent: 'center',
  marginBottom: theme.custom.spacing.medium,
  paddingLeft: theme.custom.spacing.medium,
  paddingRight: theme.custom.spacing.medium,
  p: {
    fontSize: '1.5rem'
  },
  [mq.small]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    p: {
      minWidth: 150
    }
  }
}));

const CounterStyles = {
  height: 34,
  width: 'auto',
  minWidth: 120,
  ['> div']: {
    fontSize: '1.5rem'
  }
};

export const NightsCounter = () => {
  const t: any = useI18NextContext();
  const dispatch = useDispatch();
  const duration: number = useSelector(getDealFinderDuration);
  const [durationIndex, setDurationIndex] = useState(0);
  const MIN_DURATION = head(DURATIONS);
  const MAX_DURATION = last(DURATIONS);

  const handleChange = (value: number) => {
    const newIndex = durationIndex + value - duration;
    const newValue = DURATIONS[newIndex];
    dispatch(setDuration(newValue));
  };

  useEffect(() => {
    setDurationIndex(DURATIONS.indexOf(duration));
  }, [duration]);

  return (
    <Container>
      <p>{t('form__field-label--duration')}</p>
      <Counter
        containerStyle={CounterStyles}
        count={DURATIONS[durationIndex]}
        label={t('common__label--nights')}
        disableDecrement={duration === MIN_DURATION}
        disableIncrement={duration === MAX_DURATION}
        onChange={handleChange}
        testId={TestId.dealFinder.durationCounter}
      />
    </Container>
  );
};
